// 局部 loading 动画
export default function Spinner({ size = 24, strokeWidth = 16, className = "" }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      version="1.1"
      id="L9"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enable-background="new 0 0 0 0"
    >
      <path
        d="M50,12 A38,38 0 1,1 50,88"
        fill="none"
        stroke="#dbdcef"
        stroke-width={strokeWidth}
        stroke-linecap="round"
        opacity="0.5"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          begin="0s"
          dur="1.25s"
          from="270 50 50"
          to="-90 50 50"
          repeatCount="indefinite"
        ></animateTransform>
      </path>
      <path
        d="M50,88 A38,38 0 1,1 50,12"
        fill="none"
        stroke="currentColor"
        stroke-width={strokeWidth}
        stroke-linecap="round"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="1.25s"
          from="-90 50 50"
          to="270 50 50"
          repeatCount="indefinite"
          begin="0s"
        ></animateTransform>
      </path>
    </svg>
  );
}
